export const STAMPS_USER_NOT_LOGGED_IN = 'user-not-logged/stamps/';
